import {
  faFacebookSquare,
  faLinkedin,
  faTwitterSquare,
  faWhatsappSquare,
} from '@fortawesome/free-brands-svg-icons';
import { faClone } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { Container } from './styles';

function ShareVacancy({ retorno }) {
  return (
    <Container>
      <span>Compartilhe esta vaga</span>
      <div className="container-links">
        <a
          rel="nofollow"
          target="_blank"
          href={`https://www.facebook.com/sharer/sharer.php?u=${process.env.REACT_APP_URL}/${retorno.company.company?.label}/vacancy/${retorno?.vacancy.slug}?utm_source=facebook_careerpage&utm_medium=share-pagina-de-carreira&utm_campaign=Recrutei`}
        >
          <FontAwesomeIcon icon={faFacebookSquare} color="#667085" />
        </a>
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${process.env.REACT_APP_URL}/${retorno.company.company?.label}/vacancy/${retorno?.vacancy.slug}&utm_source=linkedin_careerpage&utm_medium=share-pagina-de-carreira&utm_campaign=Recrutei`}
          id="linkedin-share-btt"
          rel="nofollow"
          target="_blank"
        >
          <FontAwesomeIcon icon={faLinkedin} color="#667085" />
        </a>
        <a
          href={
            `https://api.whatsapp.com/send?text=Veja%20essa%20vaga%20de%20${
              retorno?.vacancy?.title
            }%20${
              retorno?.vacancy?.show_location === 1 &&
              retorno?.vacancy?.remote === 1
                ? `(Remoto)`
                : retorno?.vacancy?.remote === 2
                ? `em%20` + retorno?.vacancy?.city + ` ou Remoto`
                : retorno?.vacancy?.remote === 3
                ? `em%20` + retorno?.vacancy?.city + ` e Remoto (Híbrido)`
                : `em%20` + retorno?.vacancy?.city
            }%20que%20encontrei!%20${process.env.REACT_APP_URL}/${
              retorno.company.company?.label
            }/vacancy/${retorno?.vacancy.slug}` +
            `%3Futm_source=whatsapp_careerpage`
          }
          id="whatsapp"
          target="_blank"
        >
          <FontAwesomeIcon icon={faWhatsappSquare} color="#667085" />
        </a>
        <a
          rel="nofollow"
          target="_blank"
          id="twitter"
          href={`https://twitter.com/intent/tweet?text=Veja%20essa%20vaga%20de%20${retorno?.vacancy?.title}%20em%20%20${retorno?.vacancy?.city}%20que%20encontrei%21%20&url=${process.env.REACT_APP_URL}/${retorno.company.company?.label}/vacancy/${retorno?.vacancy.slug}`}
        >
          <FontAwesomeIcon icon={faTwitterSquare} color="#667085" />
        </a>
        <a
          style={{ cursor: 'pointer' }}
          id="copy"
          rel="nofollow"
          onClick={() => navigator.clipboard.writeText(window.location.href)}
        >
          <FontAwesomeIcon icon={faClone} color="#667085" />
        </a>
      </div>
    </Container>
  );
}

export default ShareVacancy;
